module.exports = __webpack_public_path__ + "media/images/svg/logo_footer-df23f121d203f52093ded1138653dbb0.svg";